export default "__VITE_ASSET__jbbb4nLl__"